import PlaidAPI from './api'
//import options from './options'

export default class PlaidClient {
  static api = new PlaidAPI()
  //static options = options
}